import type { SanityFormConfirmation } from '#/lib/sanity/queries/formConfirmation';
import { Skeleton } from '#/components/ui/skeleton';
import { Button } from '#/components/Button';
import { Headline } from '#/components/Headline';

type Props = {
  isWaitingOnSchedulingLoad: boolean;
  confirmation: SanityFormConfirmation;
};
export function FormConfirmation(props: Props) {
  return (
    <div data-testid="form-confirmation">
      {props.confirmation.headline ? (
        <Headline value={props.confirmation.headline} variant={5} />
      ) : null}

      {props.isWaitingOnSchedulingLoad ? (
        <>
          <p className="text-body mt-15">Loading next steps...</p>
          <Skeleton className="mt-15 h-16 w-[200px]" />
        </>
      ) : (
        <>
          <p className="text-body mt-15">{props.confirmation.bodyCopy}</p>
          {props.confirmation.cta?.href ? (
            <Button
              className="mt-20"
              href={props.confirmation.cta.href}
              target={props.confirmation.cta.target}
              variant="secondary"
            >
              {props.confirmation.cta.title}
            </Button>
          ) : null}
        </>
      )}
    </div>
  );
}
